export const SET_AUTH_USER = "SET_AUTH_USER";